import script from "./TagNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TagNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TagNavigation.vue?vue&type=style&index=0&id=7fb527d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb527d8"]])

export default __exports__